// Shared input components for admin editors

export const Field = ({ label, children, full = false }) => (
  <label className={`block ${full ? "md:col-span-2" : ""}`}>
    <span className="block text-[0.65rem] tracking-[0.28em] uppercase text-sm-olive mb-2 font-medium">
      {label}
    </span>
    {children}
  </label>
);

export const TextInput = ({ value, onChange, placeholder, testid }) => (
  <input
    type="text"
    value={value || ""}
    onChange={(e) => onChange(e.target.value)}
    placeholder={placeholder}
    className="sm-admin-input w-full"
    data-testid={testid}
  />
);

export const TextArea = ({ value, onChange, placeholder, rows = 4, testid }) => (
  <textarea
    value={value || ""}
    onChange={(e) => onChange(e.target.value)}
    placeholder={placeholder}
    rows={rows}
    className="sm-admin-input w-full resize-none"
    data-testid={testid}
  />
);

export const SectionTitle = ({ children, sub }) => (
  <div className="border-b border-sm-border pb-4 mb-6">
    <h3 className="font-serif text-2xl text-sm-text">{children}</h3>
    {sub && <p className="text-sm text-sm-muted mt-1 font-light">{sub}</p>}
  </div>
);

export const Subtitle = ({ children }) => (
  <h4 className="font-serif text-lg text-sm-text mt-8 mb-4 pb-2 border-b border-sm-border/60">
    {children}
  </h4>
);
